<template>
    <div>
        <div class='panHeader'>
            <div class='panHeader0 panHeader1'>
                <el-radio-group type="danger"  size='' v-model.trim="query.dataType" @change="changeBody"> 
                    <el-radio-button label="1">数据中心</el-radio-button>    
                     <!-- <el-radio-button label="2">每日看板</el-radio-button>  -->
                    <el-radio-button label="3">数据统计</el-radio-button>  
                    <el-radio-button label="4">转化分析</el-radio-button>  
                     <!--<el-radio-button label="5">风控预警</el-radio-button>  
                    <el-radio-button label="4">资源分析</el-radio-button>   
                    <el-radio-button label="4">产品分析</el-radio-button>   
                    <el-radio-button label="4">渠道分析</el-radio-button>   
                    <el-radio-button label="4">用户分析</el-radio-button> -->
                </el-radio-group> 
            </div>
            <div class='panHeader0 panHeader2'>
                <h2>可视化数据面板</h2> 
            </div>
            <div  class='panHeader0 panHeader3'> 
                <!-- <i class='panRefresh el-icon-refresh' @click="closeCharts" style='cursor:pointer'></i> -->
                <i class='el-icon-close' @click="closeCharts" style='cursor:pointer'></i>
            </div>
             
        </div> 
        
        <body1 :style="showBody==1?'display:block':'display:none'"></body1>
        <body2 :style="showBody==2?'display:block':'display:none'"></body2>
        <body3 :style="showBody==3?'display:block':'display:none'"></body3>
        <body4 :style="showBody==4?'display:block':'display:none'"></body4>
<!--        <body1 v-if="query.dataType==1"></body1>-->
<!--        <body2 v-if="query.dataType==2"></body2>-->
<!--        <body3 v-if="query.dataType==3"></body3>-->
<!--        <body4-->
<!--               :selectData="select"-->
<!--               :select3Data="select3"-->
<!--               :select6Data="select6"-->
<!--               v-if="query.dataType==4"></body4>-->
    </div>  
    
</template>

<script> 
import bus from '../../common/bus';  
import body1 from './DataBody1.vue';
import body2 from './DataBody2.vue';
import body3 from './DataBody3.vue';
import body4 from './DataBody4.vue';

export default { 
    data() {
        return { 
            query:{dataType:'1',showFag:'1'}, 
            showBody:'1', 
            times:0,
        }
    },
     components: {  
        body1 ,
        body2 ,
        body3 ,
        body4 ,
    }, 
    mounted() {
        setTimeout( () => {
            bus.$emit('data-body1', this.query);
        }, 200) 
    }, 
    computed: {
        
    },
    created() { 
    },
    methods: {
        changeBody(){
            this.showBody = this.query.dataType;
            if(this.times!=0){
                setTimeout( () => {
                    bus.$emit('data-body'+this.query.dataType, this.query);
                }, 200)
            }
            this.times = 1;
        }, 
        
        closeCharts(){
            this.$router.push('/comOrder'); 
        }, 
    }
};
</script>


<style>
 
 .panHeader{
        width:100%;
        height: 50px; 
        padding:10px 0.5%;
        border-bottom:2px solid #ddd;
        margin:15px 0;
    }
    .panBody{
        
        height: 90vh; 
        overflow-y:scroll;
        overflow-x:hidden;
    }
    .panHeader1{
        float:left; 
        width:39%; 
    }
    .panHeader2{ 
        float:left; 
        width:20%;
        text-align: center; 
    }
    .panHeader3{ 
        line-height: 45px;
        font-size: 25px;
        text-align: right;
        float:left; 
        width:39%; 
    }
    .panHeader3 i {
        margin-right:20px;
    }
    .el-table thead{
        color:#666;
        font-weight:700;
        font-size: 15px;
    }
   


@media screen and (max-width:999px){ 
    .panHeader1{
        width:75% ;
        padding:10px 0px;
    }
    .panHeader2{
        display: none;
    }
    .panHeader {
        height:75px;
        margin:0 0 10px 0;
    }
    .panHeader3{
        width: 22%; 
        margin-top:15px;
    }
    .panHeader3 i:nth-child(1){
        margin-right:10px;
    }
    
}
 
 


</style>
